import { PropsWithChildren } from "react";
import { twMerge } from "tailwind-merge";

import { PATIENT_MEDICATION_STATUS } from "~/common/constants/medications";
import {
  MedicationNotes,
  MergedMedicationRecord,
  PatientMedicationStatus,
} from "~/common/types";
import { MedicationMessage } from "../MedicationMessage";
import { MedicationsTable } from "../MedicationsTable";

interface MedicationCardDetailsProps extends PropsWithChildren {
  status: PatientMedicationStatus;
  discontinuationTitle?: string;
  internalNote?: string;
  patientNote?: string;
  pausedScriptNote?: MedicationNotes;
  medicationName: string;
  mergedMedicationRecords?: MergedMedicationRecord[];
}

export const MedicationCardDetails = ({
  status,
  discontinuationTitle,
  internalNote,
  patientNote,
  medicationName,
  mergedMedicationRecords,
}: MedicationCardDetailsProps) => {
  return (
    <div
      className={twMerge(
        "flex flex-col gap-4 border-t border-primary-200 pt-4",
        status === PATIENT_MEDICATION_STATUS.discontinued &&
          "border-neutral-700",
      )}
    >
      {!!discontinuationTitle && (
        <div className="flex flex-col gap-2">
          <p className="text-base font-medium">{discontinuationTitle}</p>
          <div
            className={twMerge(
              "flex gap-4 border-b border-primary-200 pb-4",
              status === PATIENT_MEDICATION_STATUS.discontinued &&
                "border-neutral-700",
            )}
          >
            {internalNote && (
              <MedicationMessage title="Internal note">
                {internalNote}
              </MedicationMessage>
            )}
            {patientNote && (
              <MedicationMessage title="Message to patient">
                {patientNote}
              </MedicationMessage>
            )}
          </div>
        </div>
      )}
      <MedicationsTable
        key={mergedMedicationRecords?.length}
        medicationName={medicationName}
        mergedMedicationRecords={mergedMedicationRecords}
      />
    </div>
  );
};
